<template>
  <div id="hrms41e">
    <hrms-search-box-table v-show="indexDisp"
            v-model="searchIndex"
            :data="index"
            :nowLang="app.nowLang"
            :unLoadBool="true"
            :columns="columns[app.nowLang].index"
            :receivedStore="receivedHrms41eIndex"
            :editEvent="editEvent"
            :columnEvent="columnEvent"
            searchBoxAlias="hrms41e" /> 

    <detail v-show="detailDisp"
            :searchIndex="searchIndex"
            :indexSelected="indexSelected"
            :labels="labels[app.nowLang]"
            :labelsButton="app.button[app.nowLang]"
            :nowLang="app.nowLang"
            :toggle="toggle"
            :detail="detail"
            :detailTab2Columns="columns[app.nowLang].detailTab2"
            :postHrms41eTab1Save="postHrms41eTab1Save" />

    <input data-toggle="modal" data-target="#hrms27u-popup-applinf" ref="popupApplinf" type="hidden"/>
    <div name="hrms27u-popup-applinf" id="hrms27u-popup-applinf" class="modal fade" role="dialog">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header header-popup">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <h4 class="modal-title">{{ stdapplinfLabels[app.nowLang]['HRRC21P1']['1170'] }}</h4>
          </div>

          <div class="modal-body detail detail-responsive">
            <stdapplinf-detail  :data="stdapplinfIndex"
                                :labels="stdapplinfLabels[app.nowLang]"
                                :columns="stdapplinfColumn[app.nowLang]"
                                :dataTappoinf="dataTappoinf"
                                :receivedStdapplinfTappoinf="receivedStdapplinfTappoinf" />
          </div>
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as types from 'store/modules/hrms41e/mutation-types'
import * as stdapplinfTypes from 'store/modules/stdapplinf/mutation-types'
import detail from 'components/hrms41e/detail'
import stdapplinfDetail from 'components/stdapplinf/stdapplinfDetail'
import moment from 'moment'

export default {
  name: 'hrms41e',
  data () {
    return {
      searchIndex: {
        dteappoist: '01' + moment().format('MM/YYYY'),
        dteappoien: moment().format('DD/MM/YYYY')
      },
      app: this.$parent.$parent.$parent
    }
  },
  created () {
    this.receivedHrms41eColumnsLabels()
    this.receivedStdapplinfColumnsLabels()
  },
  computed: {
    ...mapGetters({
      indexDisp: types.GET_HRMS41E_INDEX_DISP,
      detailDisp: types.GET_HRMS41E_DETAIL_DISP,
      labels: types.GET_HRMS41E_LABELS,
      index: types.GET_HRMS41E_INDEX,
      columns: types.GET_HRMS41E_COLUMNS,
      indexSelected: types.GET_HRMS41E_INDEX_SELECTED,
      detail: types.GET_HRMS41E_DETAIL,
      stdapplinfLabels: stdapplinfTypes.GET_STDAPPLINF_LABELS,
      stdapplinfIndex: stdapplinfTypes.GET_STDAPPLINF_INDEX,
      stdapplinfColumn: stdapplinfTypes.GET_STDAPPLINF_COLUMNS,
      dataTappoinf: stdapplinfTypes.GET_STDAPPLINF_TAPPOINF
    })
  },
  methods: {
    columnEvent (eventName, param) {
      switch (eventName) {
        case 'numappl':
          this.receivedStdapplinfIndex({ numappl: param[eventName] })
          this.$refs.popupApplinf.click()
          break
      }
    },
    pageDetail (event) {
      switch (event) {
        case 'edit':
          let searchParams = {
            p_numappl: this.indexSelected.numappl,
            p_codposrq: this.indexSelected.codposrq,
            p_numapseq: this.indexSelected.numapseq,
            p_numreqrq: this.indexSelected.numreqrq
          }
          // if (this.indexSelected.codform) {
          this.receivedHrms41eDetail(searchParams)
          this.toggle('detail')
          // }
          break
        default:
          break
      }
    },
    editEvent (param) {
      this.setIndexSelected(param)
      this.pageDetail('edit')
    },
    ...mapMutations({
      setIndexSelected: types.SET_HRMS41E_INDEX_SELECTED
    }),
    ...mapActions({
      toggle: types.TOGGLE_HRMS41E_PAGE,
      receivedHrms41eColumnsLabels: types.RECEIVED_HRMS41E_COLUMNS_LABELS,
      receivedHrms41eIndex: types.RECEIVED_HRMS41E_INDEX,
      receivedHrms41eDetail: types.RECEIVED_HRMS41E_DETAIL,
      postHrms41eTab1Save: types.POST_HRMS41E_TAB1_SAVE,
      receivedStdapplinfColumnsLabels: stdapplinfTypes.RECEIVED_STDAPPLINF_COLUMNS_LABELS,
      receivedStdapplinfIndex: stdapplinfTypes.RECEIVED_STDAPPLINF_INDEX,
      receivedStdapplinfTappoinf: stdapplinfTypes.RECEIVED_STDAPPLINF_TAPPOINF
    })
  },
  components: {
    detail,
    stdapplinfDetail
  }
}
</script>




// WEBPACK FOOTER //
// component.vue?695cf1ba